module.exports = __webpack_public_path__ + "static/media/Nursery_1.97888cdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/nursery/Nursery_1.png
// module id = 1280
// module chunks = 3